import logo from "../photos/logo.png";
import { useState } from "react";
import "../../styles/common/header.css";
import { Link } from "react-router-dom";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div>
            <div className="header">
                <div className="header-color"/>

                <div className="header-top"> 
                    <div className="header-left">
                        
                        <Link to="/" className="logo-nav">
                            <div className="company-name-container">
                                <div className="logo">
                                    <img src={logo} alt="LOGO"/>
                                </div>

                                <div className="company-name">Comfort Care 24/7 </div>
                            </div>

                        </Link>
                    
                    </div>

                    <div className="header-right">
                        <div className="subtext">Get Pricing & Schedule Tour</div>
                        <div className="phone-number">951-500-0904</div>
                    </div>            
                </div>

                <div className="nav-header">
                    <Link to="/about-us">
                        <button className="nav-item-header">About Us</button>
                    </Link>

                    <Link to="/independent-living">
                        <button className="nav-item-header">Independent Living</button>
                    </Link>

                    <Link to="/#contact">
                        <button className="nav-item-header">Contact Us</button>
                    </Link>
                    
                </div>

                <div className="header-color"/>
            </div>

            <div className="header-mobile">
                <div className="header-mobile-color"/>

                <div className="mobile-header-top">
                    <Link to="/" className="mobile-logo-nav">
                        <img src={logo} alt="LOGO" className="mobile-logo"/>
                    </Link>
                    <div className={`mobile-menu-icon ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                        ☰
                    </div>
                </div>
                
                <div className={`mobile-nav ${menuOpen ? 'open' : ''}`}>
                    <Link to="/about-us" className="mobile-nav-item">About Us</Link>
                    <Link to="/independent-living" className="mobile-nav-item">Independent Living</Link>
                    <Link to="/#contact" className="mobile-nav-item">Contact Us</Link>
                </div>
                
                <div className="header-mobile-color"/>
            </div>
        </div>
    )
}

export default Header;


